import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { RadioButton } from 'components-ref/atoms'
import colors from 'styles/colors'
import { SortDirection } from 'types/enums'

interface IProps {
    sortValue: SortDirection | ''
    setSortValue: (value: SortDirection | '') => void
}

export const AnalyticsContentModalSortDirections = ({
    sortValue,
    setSortValue
}: IProps) => {
    const { t } = useTranslation()

    return (
        <ButtonsContainer>
            <FilterContainer
                onClick={e => {
                    e.stopPropagation()
                    setSortValue(
                        sortValue === SortDirection.ASCENDING
                            ? ''
                            : SortDirection.ASCENDING
                    )
                }}
            >
                {t('ascending')}
                <RadioButton active={sortValue === SortDirection.ASCENDING} />
            </FilterContainer>
            <FilterContainer
                onClick={e => {
                    e.stopPropagation()
                    setSortValue(
                        sortValue === SortDirection.DESCENDING
                            ? ''
                            : SortDirection.DESCENDING
                    )
                }}
            >
                {t('descending')}
                <RadioButton active={sortValue === SortDirection.DESCENDING} />
            </FilterContainer>
        </ButtonsContainer>
    )
}

const ButtonsContainer = styled.div`
    border-top: ${() => `1px solid ${colors.platinumGray}`};
    margin-top: 2rem;
    & > * + * {
        margin-top: 1rem;
    }
`

const FilterContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    cursor: pointer;
    margin-top: 2rem;

    font-size: 14px;
    font-weight: 600;
    line-height: 17.07px;
    text-align: left;
`
